import { identity } from "../utils";
import React from "react";

export default React.createContext({
	language: identity<"en" | "de" | "es" | "fr">("en"),
	setLanguage: (lang: "de" | "en" | "es" | "fr") => {
		console.error(`Cannot set language to ${lang} because setLanguage is not implemented.`);
	},
});
